// Arrange subscriptions based on the selected package and the monthly rate
export const arrangeSubscriptions = formData => {
  const { selectedPackage, monthlyRate, premiumSupportFee, hasPremiumSupport } = formData

  const subscriptionConfigs = [
    {
      plan: 'directfulCore',
      fee: selectedPackage === 'unlimited' ? 0 : monthlyRate || 0,
      always: true
    },
    {
      plan: 'unlimited',
      fee: monthlyRate || '',
      condition: selectedPackage === 'unlimited'
    },
    {
      plan: 'premiumSupport',
      fee: premiumSupportFee || '',
      condition: hasPremiumSupport
    }
  ]

  return subscriptionConfigs
    .filter(sub => sub.always || sub.condition)
    .map(({ plan, fee }) => ({ plan, fee }))
}

// Validate the prepay preferences form
export const validatePrepayPreferencesForm = (formData, addToast) => {
  const validations = [
    {
      condition: !formData.period,
      message: 'Please select a payment period'
    },
    {
      condition: !formData.monthlyRate || formData.monthlyRate <= 0,
      message: 'Please enter a valid monthly package fee'
    },
    {
      condition: formData.discount < 0,
      message: 'Discount cannot be negative'
    },
    {
      condition:
        formData.hasPremiumSupport &&
        (!formData.premiumSupportFee || formData.premiumSupportFee <= 0),
      message: 'Please enter a valid premium support fee'
    }
  ]

  for (const validation of validations) {
    if (validation.condition) {
      addToast(validation.message, { appearance: 'error' })
      return false
    }
  }

  return true
}

//Handle discount change with validation
export const handleDiscountChange = (e, monthlyRate, setPaymentPeriodData) => {
  const inputDiscount = Number(e.target.value)
  if (inputDiscount <= monthlyRate) {
    setPaymentPeriodData({ discount: inputDiscount })
  } else {
    setPaymentPeriodData({ discount: monthlyRate })
  }
}

// Handle referrer change with different actions
export const handleChangeReferrer = (newValue, actionMeta, setPaymentPeriodData) => {
  if (actionMeta.action === 'create-option') {
    setPaymentPeriodData({ newReferrerName: newValue.value, referrerId: null })
    return
  }

  if (actionMeta.action === 'clear') {
    setPaymentPeriodData({ referrerId: null, newReferrerName: null })
    return
  }

  if (actionMeta.action === 'select-option') {
    setPaymentPeriodData({ referrerId: newValue.value, newReferrerName: null })
  }
}
